import { getTranslation } from '../../../../../../common/react/utils/translations';

/**
 * @param {object} item - Draft pick data.
 * @param {object} currentPick - Current draft number.
 * @returns {object[]} Row data for the given pick.
 */
export const composeRowData = (item, currentPick) => {
    return {
        pick: item.pickNumber ?? '',
        club: PULSE.app.common.team.getTeamAbbr(item.teamId) ?? '',
        player: {
            givenName: item.fullName?.split(' ')[0] ?? '-',
            surname: item.fullName?.split(' ')[1] ?? '',
            selecting:
                item.pickNumber === currentPick
                    ? getTranslation('label.draftTracker.selecting')
                    : false,
            passed: item.passed ?? false,
            fatherSon: item.fatherSon ?? false,
            academy: item.academy ?? false
        },
        height: item.height
            ? item.height +
              ' ' +
              getTranslation('label.centimetre.abbreviation')
            : '-',
        weight: item.weight
            ? item.weight + ' ' + getTranslation('label.kilogram.abbreviation')
            : '-',
        dob:
            (item.dob?.split('/')[0].length === 1
                ? '0' + item.dob
                : item.dob) ?? '-',
        from: item.juniorClub ?? '-'
    };
};
